import UnsupportedBrowserNotification from 'components/common/UnsupportedBrowserNotification';
import Vue from 'vue';
import isBrowserSupported from './isBrowserSupported';

const UNSUPPORTED_BROWSER_NOTIFICATION_SEEN_COOKIE = 'unsupported-browser-notification-seen';
const UNSUPPORTED_BROWSER_NOTIFICATION_SEEN_EXPIRE_HOURS = 2;

function isUnsupportedBrowserNotificationSeen () {
  const seen = $.cookie(UNSUPPORTED_BROWSER_NOTIFICATION_SEEN_COOKIE);
  return seen && JSON.parse(seen);
}

function unsupportedBrowserNotificationSeen () {
  const expireHours = new Date().getHours() + UNSUPPORTED_BROWSER_NOTIFICATION_SEEN_EXPIRE_HOURS;
  const expires = new Date();
  expires.setHours(expireHours);
  $.cookie(UNSUPPORTED_BROWSER_NOTIFICATION_SEEN_COOKIE, JSON.stringify(true), {expires});
}

function renderUnsupportedBrowserNotification () {
  let vueComponent = null;
  return new Promise((resolve) => {
    vueComponent = new Vue({
      render (h) {
        return h(UnsupportedBrowserNotification, {
          on: {
            close () {
              unsupportedBrowserNotificationSeen();
              resolve();
            }
          }
        });
      }
    });
    vueComponent.$mount();
    document.body.append(vueComponent.$el);
  }).finally(async () => {
    const notification = vueComponent.$children[0];
    await notification.close();
    vueComponent.$el.remove();
    vueComponent.$destroy();
  });
}

export default async function checkBrowserVersion (supportedBrowsers) {
  if (!isBrowserSupported(supportedBrowsers) && !isUnsupportedBrowserNotificationSeen()) {
    return await renderUnsupportedBrowserNotification();
  }
}
